<template>
  <!--单例模式，name相同则复用一个无界实例，改变url则子应用重新渲染实例到对应路由 -->
  <WujieVue width="100%" height="100%" name="screenDisplayUi" :url="url" :sync="true"></WujieVue>
</template>

<script>
import hostMap from "../hostMap";

export default {
  data() {
    return {
      url: hostMap("//127.0.0.1:80/"),
    };
  },
  methods: {
    // jump(name) {
    //   this.$router.push({ name });
    // },
  },
};
</script>

<style lang="scss" scoped></style>
